import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=785c8b83&scoped=true"
import script from "./ModalTitle.vue?vue&type=script&lang=js"
export * from "./ModalTitle.vue?vue&type=script&lang=js"
import style0 from "./ModalTitle.vue?vue&type=style&index=0&id=785c8b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c8b83",
  null
  
)

export default component.exports